var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/organisms/card-house-pricing.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(!runtime.contextOrFrameLookup(context, frame, "compact")) {
output += "\n    <div class=\"card__content__footer__date\">\n        <div>\n            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"stayDescription"), env.opts.autoescape);
output += "</span>\n            <span> - </span>\n            <data class=\"search__result__total-price\"\n                  value=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total")), env.opts.autoescape);
output += "\">\n                ";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("totalWithDiscount", t_1, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_1);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_1);
}
output += "\n                ";
if(!runtime.contextOrFrameLookup(context, frame, "totalWithDiscount")) {
output += "\n                    ";
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total");
frame.set("totalWithDiscount", t_2, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_2);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_2);
}
output += "\n                ";
;
}
output += "\n                ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.contextOrFrameLookup(context, frame, "totalWithDiscount"),"EUR"), env.opts.autoescape);
output += "\n            </data>\n        </div>\n\n        <time datetime=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"startDate"), env.opts.autoescape);
output += "\">\n            ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"startDateFormatted")), env.opts.autoescape);
output += "\n        </time>\n    </div>\n";
;
}
output += "\n";
var t_3;
t_3 = ["search__result__price--container"];
frame.set("priceContainerClasses", t_3, true);
if(frame.topLevel) {
context.setVariable("priceContainerClasses", t_3);
}
if(frame.topLevel) {
context.addExport("priceContainerClasses", t_3);
}
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "compact") == true) {
output += "\n    ";
var t_4;
t_4 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "priceContainerClasses"),["search__result__price--container__compact"]);
frame.set("priceContainerClasses", t_4, true);
if(frame.topLevel) {
context.setVariable("priceContainerClasses", t_4);
}
if(frame.topLevel) {
context.addExport("priceContainerClasses", t_4);
}
output += "\n";
;
}
output += "\n\n";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true) {
output += "\n    <div class=\"";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "priceContainerClasses")," "), env.opts.autoescape);
output += "\">\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount")) {
output += "\n            <div class=\"search__result__price-discount\">\n                <div>";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight")), env.opts.autoescape);
output += "</div>\n                <data class=\"search__result__day-price_discount\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"), env.opts.autoescape);
output += "\">\n                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "\n                </data>\n            </div>\n            <div class=\"search__result__price\">\n                <data\n                    class=\"search__result__day-price search__result__day-price--discount\"\n                    value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount"), env.opts.autoescape);
output += "\"\n                >\n                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount"),"EUR"), env.opts.autoescape);
output += "\n                </data>\n            </div>\n        ";
;
}
else {
output += "\n            <div>";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight")), env.opts.autoescape);
output += "</div>\n            <div class=\"search__result__price\">\n                <data class=\"search__result__day-price\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"), env.opts.autoescape);
output += "\">\n                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "\n                </data>\n            </div>\n        ";
;
}
output += "\n    </div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/organisms/card-house-pricing.html.njk"] , dependencies)